// import Icon from "../../Icons";

// const Socials = () => {
//   return (
//     <section className="socials" id="contact">
//       <article className="socialbx">
//         <h3>Socials</h3>
//         <p>connect with me via various socials handles</p>
//         <div className="icon_bx">
//           <a href="https://github.com/dprasuna" className="icon">
//             <Icon name="Github" color="black" size={15} />
//           </a>
//           <a href="https://leetcode.com/prasunadash200/" className="icon">
//             <Icon name="Code" color="black" size={15} />
//           </a>
//           <a href="https://twitter.com/prasunadash" className="icon">
//             <Icon name="Twitter" color="black" size={15} />
//           </a>
//           <a
//             href="https://www.linkedin.com/in/prasuna-dash/"
//             className="icon"
//           >
//             <Icon name="Linkedin" color="black" size={15} />
//           </a>
//         </div>
//       </article>
//     </section>
//   );
// };

// export default Socials;

import Icon from "../../Icons";

const achievements = [
  { id: 9, img: require("../../assets/pic2.png"), title: "Web Dev Cert" },
  { id: 10, img: require("../../assets/ac6.jfif"), title: "Hackathons, Programming Challenges, and Coding Competitions" },
  { id: 11, img: require("../../assets/ac7.jfif"), title: "Victory in the code! 🏆" },
  { id: 12, img: require("../../assets/ac8.jfif"), title: "Marks on X: 🔥" },
  { id: 1, img: require("../../assets/achivements1.jpeg"), title: "Hackathon Winner" },
  { id: 2, img: require("../../assets/achivements2.jpeg"), title: "Best Web Developer" },
  { id: 3, img: require("../../assets/achivements3.jpeg"), title: "Excellence" },
  { id: 4, img: require("../../assets/ac1.jpeg"), title: "Winner TEAM 404" },
  { id: 5, img: require("../../assets/ac2.jpeg"), title: "IIM KOLKATA WINNER" },
  { id: 6, img: require("../../assets/ac3.jpeg"), title: "VSSUT , BURLA" },
  { id: 7, img: require("../../assets/ac4.jpeg"), title: "SMART INDIA HACKATHON" },
  { id: 8, img: require("../../assets/ac5.jpeg"), title: "IIM , KOLKATA " },
  
];

const Socials = () => {
  return (
    <section id="contact" className="socials">
      <h1>Achievements</h1> <br/>
      <div className="achievements-grid">
        {achievements.map((item) => (
          <div key={item.id} className="achievement-card">
            <img src={item.img} alt={item.title} />
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      <article className="socialbx">
        <h3>Socials</h3>
        <p>Connect with me via various social handles</p>
        <div className="icon_bx">
          <a href="https://github.com/dprasuna" className="icon">
            <Icon name="Github" color="black" size={15} />
          </a>
          <a href="https://leetcode.com/prasunadash200/" className="icon">
            <Icon name="Code" color="black" size={15} />
          </a>
          <a href="https://twitter.com/prasunadash" className="icon">
            <Icon name="Twitter" color="black" size={15} />
          </a>
          <a href="https://www.linkedin.com/in/prasuna-dash/" className="icon">
            <Icon name="Linkedin" color="black" size={15} />
          </a>
        </div>
      </article>

      <style jsx>{`
        .achievements-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
          margin-bottom: 2rem;
        }

        .achievement-card {
          background: #f3f4f6;
          border-radius: 12px;
          overflow: hidden;
          text-align: center;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .achievement-card img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        .achievement-card p {
          font-weight: 600;
          padding: 8px;
        }

        .icon_bx {
          display: flex;
          gap: 12px;
          margin-top: 16px;
        }

        @media (max-width: 1024px) {
          .achievements-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 768px) {
          .achievements-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 480px) {
          .achievements-grid {
            grid-template-columns: repeat(1, 1fr);
          }
        }
      `}</style>
    </section>
  );
};

export default Socials;
